import { SvgIconNames } from '@design';

export const getCatalystInsightIconProps = ({
  isBordered,
  isCompanyCatalyst,
  isDisabled,
}: {
  isBordered: boolean;
  isCompanyCatalyst?: boolean;
  isDisabled?: boolean;
}): {
  iconName: SvgIconNames;
  viewBox: string;
  fillColor?: string;
} => {
  if (isBordered) {
    return {
      iconName: isCompanyCatalyst ? 'PuzzleLime' : 'PuzzleCyan',
      viewBox: '0 0 34 40',
    };
  }

  const fillColor = isCompanyCatalyst
    ? 'var(--icon-decorative-lime)'
    : 'var(--icon-decorative-cyan)';

  return {
    iconName: 'PuzzleBorderless',
    viewBox: '0 0 12 12',
    fillColor: isDisabled ? 'var(--icon-soft)' : fillColor,
  };
};
